"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "af", {
  enumerable: true,
  get: function get() {
    return _index.default;
  }
});
Object.defineProperty(exports, "arDZ", {
  enumerable: true,
  get: function get() {
    return _index2.default;
  }
});
Object.defineProperty(exports, "arMA", {
  enumerable: true,
  get: function get() {
    return _index3.default;
  }
});
Object.defineProperty(exports, "arSA", {
  enumerable: true,
  get: function get() {
    return _index4.default;
  }
});
Object.defineProperty(exports, "az", {
  enumerable: true,
  get: function get() {
    return _index5.default;
  }
});
Object.defineProperty(exports, "be", {
  enumerable: true,
  get: function get() {
    return _index6.default;
  }
});
Object.defineProperty(exports, "bg", {
  enumerable: true,
  get: function get() {
    return _index7.default;
  }
});
Object.defineProperty(exports, "bn", {
  enumerable: true,
  get: function get() {
    return _index8.default;
  }
});
Object.defineProperty(exports, "ca", {
  enumerable: true,
  get: function get() {
    return _index9.default;
  }
});
Object.defineProperty(exports, "cs", {
  enumerable: true,
  get: function get() {
    return _index10.default;
  }
});
Object.defineProperty(exports, "cy", {
  enumerable: true,
  get: function get() {
    return _index11.default;
  }
});
Object.defineProperty(exports, "da", {
  enumerable: true,
  get: function get() {
    return _index12.default;
  }
});
Object.defineProperty(exports, "de", {
  enumerable: true,
  get: function get() {
    return _index13.default;
  }
});
Object.defineProperty(exports, "deAT", {
  enumerable: true,
  get: function get() {
    return _index14.default;
  }
});
Object.defineProperty(exports, "el", {
  enumerable: true,
  get: function get() {
    return _index15.default;
  }
});
Object.defineProperty(exports, "enAU", {
  enumerable: true,
  get: function get() {
    return _index16.default;
  }
});
Object.defineProperty(exports, "enCA", {
  enumerable: true,
  get: function get() {
    return _index17.default;
  }
});
Object.defineProperty(exports, "enGB", {
  enumerable: true,
  get: function get() {
    return _index18.default;
  }
});
Object.defineProperty(exports, "enIN", {
  enumerable: true,
  get: function get() {
    return _index19.default;
  }
});
Object.defineProperty(exports, "enNZ", {
  enumerable: true,
  get: function get() {
    return _index20.default;
  }
});
Object.defineProperty(exports, "enUS", {
  enumerable: true,
  get: function get() {
    return _index21.default;
  }
});
Object.defineProperty(exports, "enZA", {
  enumerable: true,
  get: function get() {
    return _index22.default;
  }
});
Object.defineProperty(exports, "eo", {
  enumerable: true,
  get: function get() {
    return _index23.default;
  }
});
Object.defineProperty(exports, "es", {
  enumerable: true,
  get: function get() {
    return _index24.default;
  }
});
Object.defineProperty(exports, "et", {
  enumerable: true,
  get: function get() {
    return _index25.default;
  }
});
Object.defineProperty(exports, "eu", {
  enumerable: true,
  get: function get() {
    return _index26.default;
  }
});
Object.defineProperty(exports, "faIR", {
  enumerable: true,
  get: function get() {
    return _index27.default;
  }
});
Object.defineProperty(exports, "fi", {
  enumerable: true,
  get: function get() {
    return _index28.default;
  }
});
Object.defineProperty(exports, "fr", {
  enumerable: true,
  get: function get() {
    return _index29.default;
  }
});
Object.defineProperty(exports, "frCA", {
  enumerable: true,
  get: function get() {
    return _index30.default;
  }
});
Object.defineProperty(exports, "frCH", {
  enumerable: true,
  get: function get() {
    return _index31.default;
  }
});
Object.defineProperty(exports, "gd", {
  enumerable: true,
  get: function get() {
    return _index32.default;
  }
});
Object.defineProperty(exports, "gl", {
  enumerable: true,
  get: function get() {
    return _index33.default;
  }
});
Object.defineProperty(exports, "gu", {
  enumerable: true,
  get: function get() {
    return _index34.default;
  }
});
Object.defineProperty(exports, "he", {
  enumerable: true,
  get: function get() {
    return _index35.default;
  }
});
Object.defineProperty(exports, "hi", {
  enumerable: true,
  get: function get() {
    return _index36.default;
  }
});
Object.defineProperty(exports, "hr", {
  enumerable: true,
  get: function get() {
    return _index37.default;
  }
});
Object.defineProperty(exports, "ht", {
  enumerable: true,
  get: function get() {
    return _index38.default;
  }
});
Object.defineProperty(exports, "hu", {
  enumerable: true,
  get: function get() {
    return _index39.default;
  }
});
Object.defineProperty(exports, "hy", {
  enumerable: true,
  get: function get() {
    return _index40.default;
  }
});
Object.defineProperty(exports, "id", {
  enumerable: true,
  get: function get() {
    return _index41.default;
  }
});
Object.defineProperty(exports, "is", {
  enumerable: true,
  get: function get() {
    return _index42.default;
  }
});
Object.defineProperty(exports, "it", {
  enumerable: true,
  get: function get() {
    return _index43.default;
  }
});
Object.defineProperty(exports, "ja", {
  enumerable: true,
  get: function get() {
    return _index44.default;
  }
});
Object.defineProperty(exports, "ka", {
  enumerable: true,
  get: function get() {
    return _index45.default;
  }
});
Object.defineProperty(exports, "kk", {
  enumerable: true,
  get: function get() {
    return _index46.default;
  }
});
Object.defineProperty(exports, "kn", {
  enumerable: true,
  get: function get() {
    return _index47.default;
  }
});
Object.defineProperty(exports, "ko", {
  enumerable: true,
  get: function get() {
    return _index48.default;
  }
});
Object.defineProperty(exports, "lb", {
  enumerable: true,
  get: function get() {
    return _index49.default;
  }
});
Object.defineProperty(exports, "lt", {
  enumerable: true,
  get: function get() {
    return _index50.default;
  }
});
Object.defineProperty(exports, "lv", {
  enumerable: true,
  get: function get() {
    return _index51.default;
  }
});
Object.defineProperty(exports, "mk", {
  enumerable: true,
  get: function get() {
    return _index52.default;
  }
});
Object.defineProperty(exports, "mn", {
  enumerable: true,
  get: function get() {
    return _index53.default;
  }
});
Object.defineProperty(exports, "ms", {
  enumerable: true,
  get: function get() {
    return _index54.default;
  }
});
Object.defineProperty(exports, "mt", {
  enumerable: true,
  get: function get() {
    return _index55.default;
  }
});
Object.defineProperty(exports, "nb", {
  enumerable: true,
  get: function get() {
    return _index56.default;
  }
});
Object.defineProperty(exports, "nl", {
  enumerable: true,
  get: function get() {
    return _index57.default;
  }
});
Object.defineProperty(exports, "nlBE", {
  enumerable: true,
  get: function get() {
    return _index58.default;
  }
});
Object.defineProperty(exports, "nn", {
  enumerable: true,
  get: function get() {
    return _index59.default;
  }
});
Object.defineProperty(exports, "pl", {
  enumerable: true,
  get: function get() {
    return _index60.default;
  }
});
Object.defineProperty(exports, "pt", {
  enumerable: true,
  get: function get() {
    return _index61.default;
  }
});
Object.defineProperty(exports, "ptBR", {
  enumerable: true,
  get: function get() {
    return _index62.default;
  }
});
Object.defineProperty(exports, "ro", {
  enumerable: true,
  get: function get() {
    return _index63.default;
  }
});
Object.defineProperty(exports, "ru", {
  enumerable: true,
  get: function get() {
    return _index64.default;
  }
});
Object.defineProperty(exports, "sk", {
  enumerable: true,
  get: function get() {
    return _index65.default;
  }
});
Object.defineProperty(exports, "sl", {
  enumerable: true,
  get: function get() {
    return _index66.default;
  }
});
Object.defineProperty(exports, "sq", {
  enumerable: true,
  get: function get() {
    return _index67.default;
  }
});
Object.defineProperty(exports, "sr", {
  enumerable: true,
  get: function get() {
    return _index68.default;
  }
});
Object.defineProperty(exports, "srLatn", {
  enumerable: true,
  get: function get() {
    return _index69.default;
  }
});
Object.defineProperty(exports, "sv", {
  enumerable: true,
  get: function get() {
    return _index70.default;
  }
});
Object.defineProperty(exports, "ta", {
  enumerable: true,
  get: function get() {
    return _index71.default;
  }
});
Object.defineProperty(exports, "te", {
  enumerable: true,
  get: function get() {
    return _index72.default;
  }
});
Object.defineProperty(exports, "th", {
  enumerable: true,
  get: function get() {
    return _index73.default;
  }
});
Object.defineProperty(exports, "tr", {
  enumerable: true,
  get: function get() {
    return _index74.default;
  }
});
Object.defineProperty(exports, "ug", {
  enumerable: true,
  get: function get() {
    return _index75.default;
  }
});
Object.defineProperty(exports, "uk", {
  enumerable: true,
  get: function get() {
    return _index76.default;
  }
});
Object.defineProperty(exports, "uz", {
  enumerable: true,
  get: function get() {
    return _index77.default;
  }
});
Object.defineProperty(exports, "vi", {
  enumerable: true,
  get: function get() {
    return _index78.default;
  }
});
Object.defineProperty(exports, "zhCN", {
  enumerable: true,
  get: function get() {
    return _index79.default;
  }
});
Object.defineProperty(exports, "zhTW", {
  enumerable: true,
  get: function get() {
    return _index80.default;
  }
});

var _index = _interopRequireDefault(require("./af/index.js"));

var _index2 = _interopRequireDefault(require("./ar-DZ/index.js"));

var _index3 = _interopRequireDefault(require("./ar-MA/index.js"));

var _index4 = _interopRequireDefault(require("./ar-SA/index.js"));

var _index5 = _interopRequireDefault(require("./az/index.js"));

var _index6 = _interopRequireDefault(require("./be/index.js"));

var _index7 = _interopRequireDefault(require("./bg/index.js"));

var _index8 = _interopRequireDefault(require("./bn/index.js"));

var _index9 = _interopRequireDefault(require("./ca/index.js"));

var _index10 = _interopRequireDefault(require("./cs/index.js"));

var _index11 = _interopRequireDefault(require("./cy/index.js"));

var _index12 = _interopRequireDefault(require("./da/index.js"));

var _index13 = _interopRequireDefault(require("./de/index.js"));

var _index14 = _interopRequireDefault(require("./de-AT/index.js"));

var _index15 = _interopRequireDefault(require("./el/index.js"));

var _index16 = _interopRequireDefault(require("./en-AU/index.js"));

var _index17 = _interopRequireDefault(require("./en-CA/index.js"));

var _index18 = _interopRequireDefault(require("./en-GB/index.js"));

var _index19 = _interopRequireDefault(require("./en-IN/index.js"));

var _index20 = _interopRequireDefault(require("./en-NZ/index.js"));

var _index21 = _interopRequireDefault(require("./en-US/index.js"));

var _index22 = _interopRequireDefault(require("./en-ZA/index.js"));

var _index23 = _interopRequireDefault(require("./eo/index.js"));

var _index24 = _interopRequireDefault(require("./es/index.js"));

var _index25 = _interopRequireDefault(require("./et/index.js"));

var _index26 = _interopRequireDefault(require("./eu/index.js"));

var _index27 = _interopRequireDefault(require("./fa-IR/index.js"));

var _index28 = _interopRequireDefault(require("./fi/index.js"));

var _index29 = _interopRequireDefault(require("./fr/index.js"));

var _index30 = _interopRequireDefault(require("./fr-CA/index.js"));

var _index31 = _interopRequireDefault(require("./fr-CH/index.js"));

var _index32 = _interopRequireDefault(require("./gd/index.js"));

var _index33 = _interopRequireDefault(require("./gl/index.js"));

var _index34 = _interopRequireDefault(require("./gu/index.js"));

var _index35 = _interopRequireDefault(require("./he/index.js"));

var _index36 = _interopRequireDefault(require("./hi/index.js"));

var _index37 = _interopRequireDefault(require("./hr/index.js"));

var _index38 = _interopRequireDefault(require("./ht/index.js"));

var _index39 = _interopRequireDefault(require("./hu/index.js"));

var _index40 = _interopRequireDefault(require("./hy/index.js"));

var _index41 = _interopRequireDefault(require("./id/index.js"));

var _index42 = _interopRequireDefault(require("./is/index.js"));

var _index43 = _interopRequireDefault(require("./it/index.js"));

var _index44 = _interopRequireDefault(require("./ja/index.js"));

var _index45 = _interopRequireDefault(require("./ka/index.js"));

var _index46 = _interopRequireDefault(require("./kk/index.js"));

var _index47 = _interopRequireDefault(require("./kn/index.js"));

var _index48 = _interopRequireDefault(require("./ko/index.js"));

var _index49 = _interopRequireDefault(require("./lb/index.js"));

var _index50 = _interopRequireDefault(require("./lt/index.js"));

var _index51 = _interopRequireDefault(require("./lv/index.js"));

var _index52 = _interopRequireDefault(require("./mk/index.js"));

var _index53 = _interopRequireDefault(require("./mn/index.js"));

var _index54 = _interopRequireDefault(require("./ms/index.js"));

var _index55 = _interopRequireDefault(require("./mt/index.js"));

var _index56 = _interopRequireDefault(require("./nb/index.js"));

var _index57 = _interopRequireDefault(require("./nl/index.js"));

var _index58 = _interopRequireDefault(require("./nl-BE/index.js"));

var _index59 = _interopRequireDefault(require("./nn/index.js"));

var _index60 = _interopRequireDefault(require("./pl/index.js"));

var _index61 = _interopRequireDefault(require("./pt/index.js"));

var _index62 = _interopRequireDefault(require("./pt-BR/index.js"));

var _index63 = _interopRequireDefault(require("./ro/index.js"));

var _index64 = _interopRequireDefault(require("./ru/index.js"));

var _index65 = _interopRequireDefault(require("./sk/index.js"));

var _index66 = _interopRequireDefault(require("./sl/index.js"));

var _index67 = _interopRequireDefault(require("./sq/index.js"));

var _index68 = _interopRequireDefault(require("./sr/index.js"));

var _index69 = _interopRequireDefault(require("./sr-Latn/index.js"));

var _index70 = _interopRequireDefault(require("./sv/index.js"));

var _index71 = _interopRequireDefault(require("./ta/index.js"));

var _index72 = _interopRequireDefault(require("./te/index.js"));

var _index73 = _interopRequireDefault(require("./th/index.js"));

var _index74 = _interopRequireDefault(require("./tr/index.js"));

var _index75 = _interopRequireDefault(require("./ug/index.js"));

var _index76 = _interopRequireDefault(require("./uk/index.js"));

var _index77 = _interopRequireDefault(require("./uz/index.js"));

var _index78 = _interopRequireDefault(require("./vi/index.js"));

var _index79 = _interopRequireDefault(require("./zh-CN/index.js"));

var _index80 = _interopRequireDefault(require("./zh-TW/index.js"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}